import { createActions, createReducer } from "reduxsauce";

export const { Types, Creators } = createActions({
    buscarRomProt: ["payload"],
    buscarRomProtSucesso: ["payload"],
    setProtSelecionado: ["payload"],
    enviarNotaFisico: ["payload"],
    enviarNotaFisicoSucesso: ["payload"],
    buscarNotasProtSele: ["payload"],
    buscarNotasProtSeleSucesso: ["payload"],
    setListaRomProtSele: ["payload"],
    setListaRomProt: ["payload"],
    onExcluirListaProtoSele: ["payload"],
    enviarRomPreviaProt: ["payload"],
    enviarRomPreviaProtSucesso: ["payload"],
    gerarProtocolo: ["payload"],
    gerarProtocoloSucesso: ["payload"],
    imprimirProtocolo: ["payload"],
    imprimirProtocoloSucesso: ["payload"],
    imprimirTodosProtocolos: ["payload"],
    imprimirTodosProtocolosSucesso: ["payload"],
    setGerarProtLoad: ["payload"],
    setCardsProt: ["payload"],
    setLoadBuscPrevProt: ["payload"],
    setLoadBuscRom: ["payload"],
    setLoadFis: ["payload"],
    setLoadPesqProt: ["payload"],
    pesquisarProtocolos: ["payload"],
    pesquisarProtocolosSucesso: ["payload"],
    fimProtocolos: ["payload"],
    exportarProtocolo: ["payload"],
    exportarProtocoloSucesso: ["payload"],
    getImagemCanhoto: ["payload"],
    getImagemCanhotoSucesso: ["payload"],
    atualizaCardsProtocolosPesquisa: ["payload"],
    imprimeComImagem: ["payload"],
    buscarNtPro: ["payload"],
    buscarNtProSucesso: ["payload"],
    loadAtivo: ["payload"],
    setListaProtocolosRemovidos: ["payload"]
});

const INIT_STATE = {
    listaRomProt: [],
    listaRomProtSele: [],
    cardsProtocolos: [],
    loadBuscPrev: false,
    loadBuscRom: false,
    loadPesqProt: false,
    protSelecionado: {
        notas: [],
        nome_remetente: ""
    },
    numPreviaProt: "",
    pdfProtocolo: [],
    loadFis: false,
    loadPro: false,
    gerarProt: {
        exibir: false,
        criando: false,
        total: 0,
        porcen: 0,
        prot: {}
    },
    listaProtocolos: [],
    listaExport: [],
    listaCanhotos: [],
    listaProtocolosComImagens: []
};

const imprimeComImagem = (state = INIT_STATE, action) => {
    const listaProtocolosComImagens = action.payload.canhotos;
    return {
        ...state,
        listaProtocolosComImagens
    };
};

const atualizaCardsProtocolosPesquisa = (state = INIT_STATE, action) => {
    let cardsProtocolos = action.payload;
    return {
        ...state,
        cardsProtocolos
    };
};

const getImagemCanhotoSucesso = (state = INIT_STATE, action) => {
    const listaCanhotos = action.payload;
    return {
        ...state,
        listaCanhotos
    };
};
const loadAtivo = (state = INIT_STATE, action) => ({
    ...state,
    loadPro: action.payload
});

const exportarProtocoloSucesso = (state = INIT_STATE, action) => {
    const lista = action.payload;

    let listaExport = [];

    lista.forEach(protocolo => {
        protocolo.notas.forEach(nota => {
            const arLength = nota.ar_nota.length;

            listaExport.push({
                protocolo: protocolo.numero,
                numeroNota: nota.ar_nota.substring(arLength - 9, arLength),
                remetente: protocolo.nome_remetente,
                remetenteCnpj: protocolo.cnpj_remetente,
                status: "Protocolada"
            });
        });
    });

    return {
        ...state,
        listaExport
    };
};

const enviarNotaFisicoSucesso = (state = INIT_STATE, action) => {
    const dados = action.payload;
    let { protSelecionado } = state;

    let cardsProtocolos = state.cardsProtocolos.slice();
    let item = {};
    let n = {};

    dados.notas.forEach(nota => {
        for (let i = 0; i < protSelecionado.notas.length; i++) {
            n = protSelecionado.notas[i];

            if (n.ar_nota === item.ar_nota) {
                n.status = item.status;

                protSelecionado.notas[i] = {
                    ...protSelecionado.notas[i],
                    status: item.status
                };

                break;
            }
        }
    });

    cardsProtocolos[protSelecionado.index] = protSelecionado;

    return {
        ...state,
        protSelecionado,
        cardsProtocolos: [...cardsProtocolos]
    };
};

const buscarRomProtSucesso = (state = INIT_STATE, action) => ({
    ...state,
    listaRomProt: action.payload
});

const setProtSelecionado = (state = INIT_STATE, action) => ({
    ...state,
    protSelecionado: {
        notas: [],
        nome_remetente: "",
        ...action.payload
    }
});

const buscarNotasProtSeleSucesso = (state = INIT_STATE, action) => ({
    ...state,
    protSelecionado: {
        ...state.protSelecionado,
        notas: action.payload
    }
});

const setListaRomProtSele = (state = INIT_STATE, action) => ({
    ...state,
    listaRomProtSele: action.payload
});

const setLoadPesqProt = (state = INIT_STATE, action) => ({
    ...state,
    loadPesqProt: action.payload
});

const enviarRomPreviaProtSucesso = (state = INIT_STATE, action) => ({
    ...state,
    cardsProtocolos: action.payload
});

const gerarProtocoloSucesso = (state = INIT_STATE, action) => {
    let cardsProtocolos = state.cardsProtocolos.slice();
    let newCardsProtocolos = action.payload;

    let result = [];

    if (newCardsProtocolos.length === 1) {
        cardsProtocolos.forEach(i =>
            newCardsProtocolos.forEach(j => {
                if (i.numero === j.numero && i.status !== j.status) {
                    i = j;
                    result.push(i);
                } else if (
                    i.protocolo_duplicado === j.numero &&
                    i.status !== j.status
                ) {
                    i = j;
                    result.push(i);
                } else {
                    result.push(i);
                }
            })
        );
        cardsProtocolos = result;
    } else {
        cardsProtocolos = newCardsProtocolos;
    }

    return {
        ...state,
        cardsProtocolos
    };
};

const imprimirProtocoloSucesso = (state = INIT_STATE, action) => ({
    ...state,
    pdfProtocolo: action.payload
});

const imprimirTodosProtocolosSucesso = (state = INIT_STATE, action) => ({
    ...state,
    pdfProtocolo: action.payload
});

const setGerarProtLoad = (state = INIT_STATE, action) => ({
    ...state,
    gerarProt: {
        ...state.gerarProt,
        ...action.payload
    }
});

const setCardsProt = (state = INIT_STATE, action) => ({
    ...state,
    cardsProtocolos: action.payload
});

const setLoadBuscPrevProt = (state = INIT_STATE, action) => ({
    ...state,
    loadBuscPrev: action.payload
});

const setLoadBuscRom = (state = INIT_STATE, action) => ({
    ...state,
    loadBuscRom: action.payload
});

const setLoadFis = (state = INIT_STATE, action) => ({
    ...state,
    loadFis: action.payload
});

const pesquisarProtocolosSucesso = (state = INIT_STATE, action) => {
    return {
        ...state,
        listaProtocolos: action.payload
    };
};

const buscarNtProSucesso = (state = INIT_STATE, action) => {
    let { cardsProtocolos } = state;
    let dados = action.payload;

    Object.keys(dados).forEach(key => {
        cardsProtocolos[key].notas = dados[key];
    });

    return {
        ...state,
        loadPro: false,
        cardsProtocolos: cardsProtocolos
    };
};

const setListaRomProt = (state = INIT_STATE, action) => {
    const { selecionados } = action.payload;

    return {
        ...state,
        listaRomProt: state.listaRomProt.filter(
            item => !selecionados.some(element => element.rom === item.rom)
        )
    };
};

const onExcluirListaProtoSele = (state = INIT_STATE, action) => {
    const { lista } = action.payload;

    return {
        ...state,
        listaRomProtSele: state.listaRomProtSele.filter(
            item => !lista.some(element => element.rom === item.rom)
        ),
        listaRomProt: [...state.listaRomProt, ...lista]
    };
};

const setListaProtocolosRemovidos = (state = INIT_STATE, action) => {
    const payload = action.payload;

    return {
        ...state,
        protocolosRemovidos: payload
    };
};

export default createReducer(INIT_STATE, {
    [Types.BUSCAR_ROM_PROT_SUCESSO]: buscarRomProtSucesso,
    [Types.SET_PROT_SELECIONADO]: setProtSelecionado,
    [Types.BUSCAR_NOTAS_PROT_SELE_SUCESSO]: buscarNotasProtSeleSucesso,
    [Types.SET_LISTA_ROM_PROT_SELE]: setListaRomProtSele,
    [Types.SET_LISTA_ROM_PROT]: setListaRomProt,
    [Types.ON_EXCLUIR_LISTA_PROTO_SELE]: onExcluirListaProtoSele,
    [Types.ENVIAR_ROM_PREVIA_PROT_SUCESSO]: enviarRomPreviaProtSucesso,
    [Types.GERAR_PROTOCOLO_SUCESSO]: gerarProtocoloSucesso,
    [Types.IMPRIMIR_PROTOCOLO_SUCESSO]: imprimirProtocoloSucesso,
    [Types.IMPRIMIR_TODOS_PROTOCOLOS_SUCESSO]: imprimirTodosProtocolosSucesso,
    [Types.SET_GERAR_PROT_LOAD]: setGerarProtLoad,
    [Types.SET_CARDS_PROT]: setCardsProt,
    [Types.ENVIAR_NOTA_FISICO_SUCESSO]: enviarNotaFisicoSucesso,
    [Types.SET_LOAD_BUSC_PREV_PROT]: setLoadBuscPrevProt,
    [Types.SET_LOAD_BUSC_ROM]: setLoadBuscRom,
    [Types.SET_LOAD_FIS]: setLoadFis,
    [Types.PESQUISAR_PROTOCOLOS_SUCESSO]: pesquisarProtocolosSucesso,
    [Types.EXPORTAR_PROTOCOLO_SUCESSO]: exportarProtocoloSucesso,
    [Types.GET_IMAGEM_CANHOTO_SUCESSO]: getImagemCanhotoSucesso,
    [Types.SET_LOAD_PESQ_PROT]: setLoadPesqProt,
    [Types.ATUALIZA_CARDS_PROTOCOLOS_PESQUISA]: atualizaCardsProtocolosPesquisa,
    [Types.IMPRIME_COM_IMAGEM]: imprimeComImagem,
    [Types.BUSCAR_NT_PRO_SUCESSO]: buscarNtProSucesso,
    [Types.LOAD_ATIVO]: loadAtivo,
    [Types.SET_LISTA_PROTOCOLOS_REMOVIDOS]: setListaProtocolosRemovidos
});
